<template>
  <div class="chart-container" :style="styles">
    <canvas ref="chart" width="100%" height="100%"></canvas>
  </div>
</template>

<script>
// Docs available on http://www.chartjs.org/docs/latest/
import { Chart, registerables } from 'chart.js'
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap'

Chart.register(...registerables, TreemapController, TreemapElement)

export default {
  name: 'Chart',

  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      chart: null,
      styles: {
        position: 'relative',
        height: this.height || '350px',
      },
    }
  },

  mounted() {
    this.renderGraph()
  },

  watch: {
    data(newValue) {
      this.updateGraph(newValue)
    },
    options(newOptions) {
      this.updateOptions(newOptions)
    },
  },

  methods: {
    renderGraph() {
      const ctx = this.$refs.chart.getContext('2d')
      this.chart = new Chart(ctx, {
        type: this.type,
        data: this.data,

        options: {
          ...this.options,
          responsive: true,
          maintainAspectRatio: false,
        },
      })
    },

    updateGraph(data) {
      if (this.chart) {
        this.chart.data = data
        this.chart.update()
      }
    },

    updateOptions(options) {
      if (this.chart) {
        this.chart.options = {
          ...this.chart.options,
          ...options,
        }
        this.chart.update()
      }
    },
  },
}
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 100%;
}
</style>
